var _ellipse, _ellipse2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressVerificationCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 25.9999,
    rx: 26,
    ry: 26.0019,
    fill: "#3158F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5569_23963",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 52,
    height: 54
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 26,
    cy: 25.9999,
    rx: 26,
    ry: 26.0019,
    fill: "#3158F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5569_23963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9712 3.99026C33.5149 3.58239 35.5768 3.14053 36.5398 2.97058C40.5616 3.99026 49.115 9.12266 51.1542 21.4948C47.5855 21.4948 49.2849 25.0637 48.945 26.9331C48.1429 31.3453 45.9995 28.406 45.2065 26.4233C44.8666 23.8741 43.0993 21.6647 41.4679 22.3445C39.8365 23.0243 37.0496 22.0613 35.86 21.4948C34.8971 21.2682 33.243 21.1209 34.3306 22.3445C35.4182 23.5682 37.0496 24.1007 37.7293 24.214C40.3916 24.7238 40.6182 26.2533 37.0496 27.273C28.9372 29.591 28.043 21.3249 28.213 19.9653C28.3489 18.8776 25.7773 17.8126 24.4744 17.4161C22.0953 15.8866 23.6247 14.527 24.4744 14.1871C25.3944 13.819 27.5332 14.6969 28.213 13.5073C28.7568 12.5556 28.0997 12.0911 27.7032 11.9778C27.0801 11.8078 25.2901 11.9778 23.1149 14.0171C20.396 16.5663 17.677 13.1674 17.5071 12.9975C17.3372 12.8275 16.8274 12.1477 15.9777 12.3177C15.2979 12.4536 14.4483 12.3743 14.1084 12.3177C13.2587 12.1477 13.4287 11.298 13.9385 10.7881C14.4191 10.3075 16.6008 9.65516 17.677 9.42857C18.9799 9.37192 21.9594 8.74878 23.4548 6.70941C24.9502 4.67005 27.7032 4.04691 28.8927 3.99026C30.0256 4.16021 32.4274 4.39814 32.9712 3.99026Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7489 7.21926C11.6613 6.81138 11.5027 5.57644 11.5594 5.00995C14.7313 2.46074 21.1091 -1.8899 21.245 1.10117C21.415 4.84 19.3757 7.55915 17.5071 6.36952C15.6385 5.17989 14.9574 6.36952 14.7875 6.36952C14.6176 6.36952 14.1084 7.7291 12.7489 7.21926Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1993 12.4873C8.15955 12.3514 6.40385 14.3568 5.78097 15.3764C5.23718 15.6484 5.21452 16.2828 5.27117 16.5661C5.54306 17.2459 6.17748 16.8493 6.46071 16.5661C6.63064 16.1695 7.44633 15.4784 9.3496 15.8863C11.2529 16.2942 11.9553 15.3764 12.0686 14.8666C12.2953 14.1302 12.239 12.6233 10.1993 12.4873Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3611 43.845C26.1375 44.3888 25.6051 45.9977 25.4918 46.7341C25.0534 48.0942 26.1715 48.7729 27.3611 47.7533C28.5506 46.7336 29.9101 46.9035 30.7597 47.0735C31.6094 47.2434 33.8186 47.0737 35.0081 44.6945C36.1977 42.3152 34.1584 41.9753 33.4787 42.825C32.9349 43.5048 31.5528 43.675 30.9297 43.6751C30.2499 43.5051 28.5846 43.3012 27.3611 43.845Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83615 11.8957C7.88451 12.1676 6.40042 13.8218 5.77732 14.6148C5.4941 15.0113 5.02961 15.9061 5.43746 16.314C5.8453 16.7218 6.40042 16.144 6.627 15.8041C6.91022 15.521 7.81654 15.0566 9.17602 15.4642C10.5355 15.8718 11.4418 15.2944 11.725 14.9547C13.5943 11.5555 10.0257 11.5558 8.83615 11.8957Z",
    fill: "#0F28E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.627 30.7595C1.46091 26.4088 3.90801 21.8089 5.77732 20.0528C7.64636 18.5233 9.68607 20.0528 12.9148 17.6735C15.4978 15.7701 17.6164 16.9938 18.3527 17.8435C18.8059 18.2967 20.392 19.2031 23.1109 19.2031C26.5096 19.2031 26.3397 22.2621 26.6795 24.6414C27.0194 27.0206 26.8495 26.3408 29.0586 29.3999C31.2678 32.4589 33.4769 31.2693 35.0063 31.7791C36.5357 32.289 36.3658 34.3283 35.0063 36.0278C33.6469 37.7273 30.2482 38.0672 27.6991 39.7666C25.1501 41.4661 24.8103 43.6754 23.9606 45.5448C23.1109 47.4143 22.771 47.7542 21.0717 48.0941C19.3723 48.4339 17.8429 45.035 17.8429 41.6361C17.8429 38.2371 15.8037 35.518 13.5946 34.6682C11.3854 33.8185 9.17602 32.6289 6.627 30.7595Z",
    fill: "#0F28E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressVerificationCheckLarge);
export default __webpack_public_path__ + "static/media/address_verification_check_large.ec2efe2763a208817b9c655b6d9887d1.svg";
export { ForwardRef as ReactComponent };